import React, { useEffect } from "react";
import { Drawer } from "@mui/material"; // O il tuo componente Drawer preferito
import { RiCloseLine } from "react-icons/ri"; // O il tuo pacchetto di icone preferito
import NotificationTile from "../NotificationTile";
import { NotificationData } from "../../api/NotificationApi";

interface NotificationListProps {
  open: boolean;
  isLoading: boolean;
  onClose: () => void;
  notifications: NotificationData[];
  onNotificationClick: (data: NotificationData) => void;
}

const NotificationDrawer: React.FC<NotificationListProps> = ({
  open,
  isLoading,
  onClose,
  notifications,
  onNotificationClick,
}) => {
  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <div className="w-[365px] box-border">
        <div className="sticky top-0 w-full px-6 pt-10 pb-6 border-b bg-secondaryColor-100 border-b-secondaryColor-200">
          <span className="text-xl font-bold">Lista notifiche</span>
          <RiCloseLine
            className="absolute cursor-pointer top-6 right-4"
            onClick={onClose}
          />
        </div>
        {isLoading === false &&
          notifications.map((notification, index) => (
            <NotificationTile
              key={index}
              title={notification.title}
              description={notification.body ?? ""}
              arrivedAt={notification.send_date ?? ""}
              isRead={notification.read_date !== null}
              onNotClick={() => onNotificationClick(notification)}
            />
          ))}
      </div>
    </Drawer>
  );
};

export default NotificationDrawer;
